/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Orders_All_Orders_Already_StatusInputs */

const en_orders_all_orders_already_status = /** @type {(inputs: Orders_All_Orders_Already_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All selected orders are already ${i?.status}.`)
};

const es_orders_all_orders_already_status = /** @type {(inputs: Orders_All_Orders_Already_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todos los pedidos seleccionados ya estan en ${i?.status}.`)
};

/**
* | output |
* | --- |
* | "All selected orders are already {status}." |
*
* @param {Orders_All_Orders_Already_StatusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_all_orders_already_status = /** @type {((inputs: Orders_All_Orders_Already_StatusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_All_Orders_Already_StatusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_all_orders_already_status(inputs)
	return es_orders_all_orders_already_status(inputs)
});